export default [
    '/tuan'
]